import { serviceHandler } from './service-executor';

export const performDemoRequest = (user) => {
  const headers = {
    'X-Auth-Username': user.email,
    'X-Auth-Password': btoa(user.password)
  };
  const URL = '/api/demo/request';
  return serviceHandler(URL, 'POST', user, headers);
};